import { FormControl, MenuItem, FormHelperText } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { getContractActivityTypes } from '../../fetch';
import { IDropdownResponse } from '../../models';
import { SMBSelect } from '../input';

interface IActivityTypeDropdownProps {
  value: string | number;
  handleChange: (val: string) => void;
  isDisabled?: boolean;
  setOptions?: (val: IDropdownResponse[]) => void;
  isRequired?: boolean;
  message?: string;
  hasError?: boolean;
  id: string;
}

export const ActivityTypeDropdown: FC<IActivityTypeDropdownProps> = ({
  isDisabled,
  isRequired,
  value,
  handleChange,
  setOptions,
  message,
  hasError,
  id
}) => {
  const { isLoading, data: documentStatuses } = useQuery<IDropdownResponse[], Error>(
    [id ?? 'getContractActivityTypes'],
    () => getContractActivityTypes(),
    {
      notifyOnChangeProps: 'tracked',
      onSuccess: d => setOptions?.(d)
    }
  );
  return (
    <FormControl fullWidth variant="outlined" size="small" required={isRequired} error={hasError}>
      <SMBSelect
        disabled={isDisabled || isLoading}
        label={isLoading ? 'Loading...' : 'Activity Type'}
        value={value}
        size="small"
        required={isRequired}
        onChange={({ target: { value } }) => {
          handleChange(value as string);
        }}
        handleClear={() => handleChange('')}
      >
        {!isLoading && documentStatuses && documentStatuses.length === 0 && (
          <MenuItem disabled>No data available</MenuItem>
        )}
        {!isLoading &&
          documentStatuses &&
          documentStatuses?.map((d, index) => {
            return (
              <MenuItem key={d.value} value={d.value}>
                {d.shorthand}
              </MenuItem>
            );
          })}
      </SMBSelect>
      {message && <FormHelperText error>{message}</FormHelperText>}
    </FormControl>
  );
};
